import { errorCodes } from '@/constants';
import { vuexEventPathGenerator } from '@/utils';
export const actionType = {
    setSnackbarShow: 'setSnackbarShow',
    showSuccess: 'showSuccess',
    showError: 'showError',
    showInfo: 'showInfo',
};
export const snackbarActionType = vuexEventPathGenerator(actionType, 'snackbar');
const action = {
    [actionType.setSnackbarShow]({ commit }, show) {
        commit('SET_SHOW', show);
    },
    /** 성공 케이스 */
    [actionType.showSuccess]({ commit }, payload = '') {
        const data = typeof payload === 'string'
            ? {
                message: payload,
            }
            : payload;
        commit('SHOW_SUCCESS', data);
    },
    /** 에러 케이스 */
    [actionType.showError]({ commit }, payload = '') {
        const data = typeof payload === 'string'
            ? {
                message: payload,
            }
            : payload;
        // 취소된 API에 의한 스낵바는 노출하지 않습니다.
        if (payload.message === errorCodes.ERR_CANCELED.message) {
            return;
        }
        commit('SHOW_ERROR_MESSAGE', data);
    },
    /** 경고 케이스 (느낌표) */
    [actionType.showInfo]({ commit }, payload = '') {
        const data = typeof payload === 'string'
            ? {
                message: payload,
            }
            : payload;
        // 취소된 API에 의한 스낵바는 노출하지 않습니다.
        if (payload.message === errorCodes.ERR_CANCELED.message) {
            return;
        }
        commit('SHOW_INFO_MESSAGE', data);
    },
};
export default action;
